import axios from "axios";
import { reportClientError } from "./clientLogger";

// export default axios.create({
//   // baseURL: "https://sritrangapi.kivaru.com:4433/",
//   baseURL: process.env.REACT_APP_BASE_API,
// });

const apiExcept = "api/auth/login";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
});

instance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    console.log(error.response);

    // ไม่มี response = network error / server down / CORS / timeout
    // (เดิมบรรทัดล่างจะ throw เองเพราะอ่าน .config ของ undefined)
    if (!error || !error.response) {
      reportClientError({
        level: "error",
        message: (error && error.message) || "Network Error (no response)",
        url: (error && error.config && error.config.url) || window.location.href,
        meta: { kind: "api-network", code: error && error.code },
      });
      return Promise.reject(error);
    }

    const _url = error.response.config.url;

    // รายงาน API error ทุกตัว (ยกเว้น endpoint client-log เอง กัน loop)
    if (_url.indexOf("client-log") === -1) {
      let data = error.response.data;
      try {
        data = typeof data === "string" ? data.slice(0, 500) : JSON.parse(JSON.stringify(data));
      } catch (e) {
        data = undefined;
      }
      reportClientError({
        level: error.response.status >= 500 ? "error" : "warn",
        message: "API " + error.response.status + " " + _url,
        url: _url,
        status: error.response.status,
        meta: {
          kind: "api",
          method: error.response.config && error.response.config.method,
          data: data,
        },
      });
    }

    if (_url.indexOf(apiExcept) === -1) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        window.location = "/login";
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  }
);

export default instance;

export function setDefaultURL(url) {
  instance.defaults.baseURL = url;
}
